import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { InvoicesService } from '../_services/invoices.service';
import { DataService } from '../_helpers/dataservice.service'
import { ActivatedRoute } from '@angular/router';

import { Account, Invoice } from '../_models';

@Component({
  selector: 'app-accordiondata',
  templateUrl: './accordiondata.component.html',
  styleUrls: ['accordiondata.component.css']
})
export class AccordiondataComponent implements OnInit, OnChanges {

  // Variable indicating that it will be of type FormGroup
  public invoiceForm: FormGroup;

  // Variable indicating that it will be the invoice public key
  public invoicePublic_key: any;

  // Variables that will be used to indicate the status of debts
  isOverdue: boolean;
  isVoided: boolean;
  isExpired: boolean;
  isReversed: boolean;
  isOpen: boolean;

  // Variable to indicate whether the account is CORPORATE or PAYMENTS
  APP: string;

  // Through this input I will PULL from the main component the 
  // cusAccountPublicKey_temp to render it through the HTML in the select options
  @Input() cusAccountPublicKey_temp: Account[] = [];
  @Input() currencySymbol: undefined|string;
  @Input() isDueDatetimeEdit: boolean;

  // By means of this Output I will TAKE from this component to the main component
  //  the form with every change that occurs inside
  // FormGroup typing
  @Output() formData = new EventEmitter<FormGroup>()

  // I initialize the services I am going to use
  constructor(
    private _fb: FormBuilder,
    private invoicesService: InvoicesService,
    private dataService: DataService,
    private route: ActivatedRoute
  ) {

    // I initialize the services I am going to use
    this.dataService.currentInvoicePublicKey.subscribe((data) => {
      this.invoicePublic_key = data;
    });

    this.InitialSetup();

  }

  ngOnInit() {

    this.APP = localStorage.getItem('application');

    // I bring from the route the public key of the invoice 
    let params: any = this.route.snapshot.params;
    this.invoicePublic_key = params.id;

    this.setInvoiceDetails();
  
  }

  ngOnChanges() {
    if (this.currencySymbol !== undefined) {
      this.invoiceForm.get('late_fee.currency').setValue(this.currencySymbol);
      this.invoiceForm.get('fees.currency').setValue(this.currencySymbol);
    };
    
    if (this.isDueDatetimeEdit === true) {
      this.invoiceForm.get('late_fee.value').setValue(0);
    }; 
  }

  InitialSetup() {
    this.invoiceForm = this._fb.group({
      late_fee: this._fb.group({
        currency: new FormControl("Seleccione"),
        value: new FormControl(0)
      }),
      fees: this._fb.group({
        currency: new FormControl("Seleccione"),
        value: new FormControl(0)
      })
    })
  };

  setInvoiceDetails() {
    if (this.invoicePublic_key != null && this.invoicePublic_key != 'invoice Key') {
      this.invoicesService.getInvoice(this.invoicePublic_key).subscribe({
        next: (invoice: Invoice) => {

          // Functions that return a boolean value according to the invoice status
          this.isOverdue = invoice.status === "OVERDUE" ? true : false;
          this.isVoided = invoice.status === "VOIDED" ? true : false;
          this.isExpired = invoice.status === "EXPIRED" ? true : false;
          this.isReversed = invoice.status === "REVERSED" ? true : false;

          this.setForm();

          // I set the values of the form with the response from the observable
          this.invoiceForm = this._fb.group({
            late_fee: this._fb.group({
              currency: new FormControl(invoice.late_fee.currency),
              value: new FormControl(invoice.late_fee.value)
            }),
            fees: this._fb.group({
              currency: new FormControl(invoice.fees.currency),
              value: new FormControl(invoice.fees.value)
            })
          });

          // I get the values of the two fields to display the accordion if at least 
          // one of them has a value different from 0
          let late_feeValueForm = this.invoiceForm.get('late_fee.value').value;
          let feesValueForm = this.invoiceForm.get('fees.value').value;

          if (late_feeValueForm != 0 || feesValueForm != 0) {
            this.isOpen = true;
          } else {
            this.isOpen = false;
          };

        },
        complete: () => {

          // When the "next" is completed, I make sure in the "complete" I set the valueChanges listener
          //  of the form and inside that, Output emits their data.
          this.invoiceForm.valueChanges.subscribe({
            next: data => {
              this.formData.emit(data);
            }
          });
        }
      });
    } 
  };

  // Function that identifies whether the account is CORPORATE or any of the following statuses indicated to 
  // disable the two fields by means of the reactive form
  setForm() {
    if((this.APP === 'CORPORATE') || (this.isVoided || this.isExpired || this.isReversed)) {
        this.invoiceForm.controls['late_fee'].disable();
        this.invoiceForm.controls['fees'].disable();
    } 
  };

}
